<template>
  <router-view />
</template>
<script setup>
// import mqtt from "mqtt"; // npm install mqtt
import { getToken, clearToken, setToken ,setStorage, getStorage, removeStorage} from '@/utils'
import mqtt from 'mqtt/dist/mqtt.min'
import { onMounted, onUnmounted, ref } from "vue";
let mqttClient = null;
const connectCount = ref(0);
onMounted(() => {
  mqttConnect();
});
onUnmounted(() => {
  mqttClient.end();
  console.log("------断开连接------");
  clearToken()
});
// MQTT链接
const mqttConnect = () => {
  var data = {
    clientId: "fire_cabinet_front"+ Math.random() * 100000,
    username: "dc",
    password: "gddc@888888",
    connectTimeout: 40000,
    reconnectPeriod: 0,
  };
  mqttClient = mqtt.connect("ws://www.dcoled.cn:8083/mqtt", data);
  mqttClient.on("connect", () => {
    connectCount.value = 0;
    console.log("------连接成功------");
    // 订阅主题
    mqttClient.subscribe("/dc/fire_cabinet_front", (err) => {
      if (!err) {
        console.log("------订阅成功------");
      } else {
        console.log("------订阅失败------");
      }
    });
  });
  mqttClient.on("message", (topic, message) => {
    // 处理接收到的消息
    console.log(`------接收推送信息------ ${topic}: ${message.toString()}`);
  });
  // 断开发起重连
  mqttClient.on("reconnect", (error) => {
    console.log("------正在重连------", error);
  });
  // 链接异常处理
  mqttClient.on("error", (error) => {
    console.log("------连接失败------", error);
    scheduleReconnect();
  });
  // 连接关闭
  mqttClient.on("close", (error) => {
    console.log("------连接关闭------", error);
    scheduleReconnect();
  });
};
// 定时尝试重连
const scheduleReconnect = () => {
  connectCount.value++;
  if (connectCount.value < 10) {
    setTimeout(() => {
      mqttConnect();
    }, 5000);
  }
};
</script>
<style lang="scss">
#app,
body,
html {
  width: 100%;
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
}
</style>
